import SpotlightSearch from "../SpotlightSearch/SpotlightSearch";
import "./App.styles";
import { queryClient } from "@app/config/api/api";
import { useSubscribeWebsocketEvents } from "@lib/websocket/useSubscribeWebsocketEvents";
import { ModalsProvider } from "@mantine/modals";
import { Notifications } from "@mantine/notifications";
import { QueryClientProvider } from "@tanstack/react-query";
import { usePostHog } from "posthog-js/react";
import { useEffect } from "react";
import { Outlet, ScrollRestoration, useLocation } from "react-router";

export default function App() {
  const posthog = usePostHog();
  const location = useLocation();

  useSubscribeWebsocketEvents();

  useEffect(() => {
    // Capture pageviews manually on route changes. SDK auto-pageview is disabled in posthog.ts
    // so that no events fire before identify() — this component only renders after the auth guard
    // confirms the user is authenticated and identified.
    posthog.capture("$pageview", { url: location.pathname + location.search });
  }, [posthog, location]);

  return (
    <QueryClientProvider client={queryClient}>
      <Notifications position="bottom-center" />
      <ModalsProvider>
        <ScrollRestoration />
        <SpotlightSearch />
        <Outlet />
      </ModalsProvider>
      {/* <ReactQueryDevtools initialIsOpen={false} /> */}
    </QueryClientProvider>
  );
}
